import api, { setToken } from '@/common/api.js'
import router from '@/router'

export default {
  namespaced: true,

  state: {
    filial: null,
    filiaisTemp: null,
    filialPainel: null,
    allFiliais: null,
    fornecedores: null,
    infColab: null,

    contadores: null,
    atendimentosCriticidade: null,
    placasOs: null,
    placasExternas: null,
    tipoOrdem: null,
    notasMecanicos: null,
  },

  getters: {
    filial: (state) => {
      if (state.filial && state.filial.token && state.filial) {
        return state.filial
      }

      return null
    },
    filialPainel: (state) => {
      if (state.filialPainel) {
        return state.filialPainel
      }

      return null
    },
    token: (state) => {
      if (state.filial && state.filial.token) {
        return state.filial.token
      }

      return null
    },
    fornecedores: (state) => {
      return state.fornecedores
    },
    getContadores: (state) => {
      return state.contadores
    },
    getNotasMecanicos: (state) => {
      return state.notasMecanicos
    },
    getPlacasOs: (state) => {
      return state.placasOs
    },
    getTipoOrdem: (state) => {
      return state.tipoOrdem
    },
    getPlacasExternas: (state) => {
      return state.placasExternas
    },
    getAtendimentosCriticidade: (state) => {
      return state.atendimentosCriticidade
    },
    allFiliais: (state) => {
      return state.allFiliais
    },
  },

  actions: {
    async getContadores({ commit }) {
      try {
        const response = await api.get(`dashboard/getContadores`)

        commit('setContadores', response.data)
      } catch (error) {
        commit('setContadores', [])
        throw Error(error)
      }
    },

    async getAtendimentosCriticidade({ commit }) {
      try {
        const response = await api.get(`dashboard/getAtendimentosCritididade`)

        commit('setAtendimentosCriticidade', response.data)
        return response
      } catch (error) {
        commit('setAtendimentosCriticidade', [])
        throw Error(error)
      }
    },

    async getProdutividadeMecanico({ commit }) {
      try {
        const response = await api.get(`dashboard/getProdutividadeMecanico`)

        // commit('setAtendimentosCriticidade', response.data)
        return response
      } catch (error) {
        commit('setAtendimentosCriticidade', [])
        throw Error(error)
      }
    },

    async getPlacasOs({ commit }) {
      try {
        const response = await api.get(`dashboard/getPlacasOs`)

        commit('setPlacasOs', response.data)
        return response
      } catch (error) {
        commit('setAtendimentosCriticidade', [])
        throw Error(error)
      }
    },

    async getTipoOrdem({ commit }) {
      try {
        const response = await api.get(`dashboard/getTipoOrdem`)

        commit('setTipoOrdem', response.data)
        return response
      } catch (error) {
        commit('setAtendimentosCriticidade', [])
        throw Error(error)
      }
    },

    async getNotasMecanicos({ commit }) {
      try {
        const response = await api.get(`dashboard/getNotasMecanicos`)

        commit('setNotasMecanicos', response.data)
        return response
      } catch (error) {
        commit('setNotasMecanicos', [])
        throw Error(error)
      }
    },

    async getPlacasExternas({ commit }) {
      try {
        const response = await api.get(`dashboard/getPlacasExternas`)

        commit('setPlacasExternas', response.data)
        return response
      } catch (error) {
        commit('setPlacasExternas', [])
        throw Error(error)
      }
    },

    async getProblemasRepetidos({ commit }) {
      try {
        const response = await api.get(`dashboard/getProblemasRepetidos`)

        // commit('setPlacasExternas', response.data)
        return response
      } catch (error) {
        commit('setPlacasExternas', [])
        throw Error(error)
      }
    },

  },

  mutations: {
    setContadores(state, data) {
      state.contadores = data
    },
    setPlacasOs(state, data) {
      state.placasOs = data
    },
    setTipoOrdem(state, data) {
      state.tipoOrdem = data
    },
    setNotasMecanicos(state, data) {
      state.notasMecanicos = data
    },
    setPlacasExternas(state, data) {
      state.placasExternas = data
    },
    setAtendimentosCriticidade(state, data) {
      state.atendimentosCriticidade = data
    },
    setAllFiliais(state, fornecedores) {
      state.fornecedores = fornecedores
    },
    setFilial(state, filial) {
      localStorage.filial = JSON.stringify(filial)
      setToken(api)
      state.filial = filial
    },
    setFilialPainel(state, filial) {
      localStorage.filialPainel = JSON.stringify(filial)
      state.filialPainel = filial
    },

    unsetFilial(state) {
      localStorage.removeItem('filial')
      state.filial = null
      router.push('/login')
    },

    unsetFilialPainel(state) {
      localStorage.removeItem('filialPainel')
      state.filialPainel = null
      router.push('/loginPainel')
    }
  }
}
